const SvgArrowRight = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
    <path d="M22.667 16 12 24V8z" />
  </svg>;
export default SvgArrowRight;